import { render, staticRenderFns } from "./TradingOrderBookExtraTable.vue?vue&type=template&id=302ac2e4&scoped=true&"
import script from "./TradingOrderBookExtraTable.vue?vue&type=script&lang=js&"
export * from "./TradingOrderBookExtraTable.vue?vue&type=script&lang=js&"
import style0 from "./TradingOrderBookExtraTable.vue?vue&type=style&index=0&id=302ac2e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302ac2e4",
  null
  
)

export default component.exports